export default {"src":"/_next/static/media/blcn.3cdf9b4e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};